(function () {
  if (window.cmFormatsPret) return;
  window.cmFormatsPret = true;

  var SEL = 'details.cp-fmt__groupe';

  function fermerTout(sauf) {
    document.querySelectorAll(SEL + '[open]').forEach(function (d) {
      if (d !== sauf) d.open = false;
    });
  }

  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;

    var groupe = cible.closest(SEL);

    if (groupe) {

      if (cible.closest('summary')) {
        requestAnimationFrame(function () {
          fermerTout(groupe);
        });
        return;
      }

      if (cible.closest('.cp-fmt__tailles')) return;
    }

    fermerTout(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermerTout(null);
  });

  function majFleche(liste, bouton) {
    var reste = liste.scrollWidth - liste.clientWidth - liste.scrollLeft;
    bouton.hidden = reste <= 2;
  }

  document.querySelectorAll('.cp-fmt__rangee').forEach(function (rangee) {
    var liste = rangee.querySelector('.cp-fmt__list');
    var bouton = rangee.querySelector('.cp-fmt__fleche');
    if (!liste || !bouton) return;

    majFleche(liste, bouton);

    liste.addEventListener('scroll', function () {
      majFleche(liste, bouton);
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        majFleche(liste, bouton);
      }).observe(liste);
    }

    bouton.addEventListener('click', function () {
      var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      liste.scrollBy({
        left: Math.round(liste.clientWidth * 0.8),
        behavior: doux ? 'smooth' : 'auto'
      });
    });
  });
})();
